import {Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {ForgotComponent} from './forgot/forgot.component';
import {LookScreen} from './lock-screen/lock-screen.component';

export const AuthenticationRoutes: Routes = [
  {
    path: ' ',
    component: LoginComponent,
    data: {breadcrumb: 'Login'}
  }, {
    path: 'login',
    component: LoginComponent,
    data: {breadcrumb: 'Login'}
  }, {
    path: 'lock-screen',
    component: LookScreen
  }
];





// WEBPACK FOOTER //
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/pages/authentication/authentication.routing.ts